import { parseFetchAllRequest as parseAllRequest } from 'containers/App/modules/entities/users/users.parsers';

export const parseFetchAllRequest = payload => {
    return parseAllRequest({ ...payload, filters: { ...payload.filters, manufacturerId: payload.deviceId } });
}

export const parseFetchAllSuccess = responseData => {
	return responseData.data;
};